module.exports = __webpack_public_path__ + "static/media/29COICT8.a7b39622.jpg";